import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { ModelActionsModal } from '@models-global/model-actions';
import { ClaimsCEsContactParams } from '@module-claims/models/claim-ce.interface';
import * as actions from '@module-claims/store/claim-ce.actions';

export interface IClaimCEContactModalState {
  readonly action?: ModelActionsModal;
  readonly data?: ClaimsCEsContactParams;
}

@State<IClaimCEContactModalState>({
  name: 'IClaimCEContactModalState',
  defaults: {
    action: undefined,
    data: undefined
  }
})
@Injectable()
export class ClaimCEContactModalState {
  @Action(actions.Contact340BAuditClaimsCEsModalSave)
  saveModal(
    ctx: StateContext<IClaimCEContactModalState>,
    { params }: actions.Contact340BAuditClaimsCEsModalSave
  ): void {
    ctx.patchState({
      action: 'save',
      data: params
    });
  }

  @Action(actions.Contact340BAuditClaimsCEsModalClose)
  closeModal(ctx: StateContext<IClaimCEContactModalState>): void {
    ctx.patchState({
      action: 'close',
      data: undefined
    });
  }
}
